import { useState } from "react";
import { Globe, X } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

const DISMISS_KEY = "protocall_currency_banner_dismissed";

export default function CurrencyBanner() {
  const { code, currencies, setCurrency, autoDetected } = useCurrency();
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && localStorage.getItem(DISMISS_KEY) === "1"
  );

  // Only surface for first-time visitors whose currency was auto-detected as non-XCD.
  if (dismissed || !autoDetected || code === "XCD") return null;

  const dismiss = () => {
    setDismissed(true);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  const current = currencies.find((c) => c.code === code);

  return (
    <div className="bg-slate-900 text-white" data-testid="currency-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 flex items-center justify-center gap-x-3 gap-y-1 text-sm flex-wrap">
        <span className="flex items-center gap-2">
          <Globe className="w-4 h-4 text-orange-400 flex-shrink-0" />
          Prices shown in <strong>{current?.label || code}</strong> — tap to change:
        </span>
        <div className="flex items-center gap-1.5">
          {currencies.map((c) => (
            <button
              key={c.code}
              onClick={() => {
                setCurrency(c.code);
                if (c.code === "XCD") dismiss();
              }}
              data-testid={`currency-banner-option-${c.code}`}
              className={`px-2.5 py-0.5 rounded-full text-xs font-semibold border transition-colors ${
                code === c.code
                  ? "bg-orange-500 border-orange-500 text-white"
                  : "border-white/30 text-white/80 hover:border-white hover:text-white"
              }`}
            >
              {c.code}
            </button>
          ))}
        </div>
        <button
          onClick={dismiss}
          data-testid="currency-banner-dismiss"
          aria-label="Dismiss currency notice"
          className="ml-1 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
